import React from 'react';
import './HeartIcon.less';

export default function HeartIcon({
    iconClass,
    iconClassBg,
    isAbacusLoadingTestOn,
    isModalHeart
}) {
    const bkgdIconClass = `react-trip-board-button__heart-core-bg ${iconClassBg}`;
    let height = '15px';
    let viewBox = '-1 -1 18 15';
    let width = '17px';

    if (isAbacusLoadingTestOn) {
        height = '40px';
        viewBox = '-10 -12 36 35';
        width = '40px';
    }

    return (
        <div className="react-trip-board-button__heart-core">
            <svg
                height={height}
                viewBox={viewBox}
                width={width}
            >
                {!isModalHeart &&
                    <path
                        className={bkgdIconClass}
                        d="M14.1294135,7.57785915 L9.1813451,12.5257519 C8.40187017,13.3051991 7.13698698,13.3040721 6.35866678,12.5257519 L1.41077405,7.57785915 C0.543404248,6.78002342 -8.8817842e-16,5.63564613 -8.8817842e-16,4.3646175 C-8.8817842e-16,1.9541783 1.95395254,0 4.3646175,0 C5.60449125,0 6.72403494,0.517216091 7.51825852,1.3473355 C7.60675643,1.43944557 7.69073914,1.53539356 7.76998089,1.63472794 C7.84989992,1.53539356 7.93365686,1.43944557 8.02170325,1.3473355 C8.81615259,0.517216091 9.93569628,0 11.1753443,0 C13.5860092,8.02060533e-16 15.5399618,1.9541783 15.5399618,4.3646175 C15.5399618,5.63564613 14.9965575,6.78024918 14.1294135,7.57785915 Z"
                    />
                }
                <path
                    className={iconClass}
                    d="M14.1294135,7.57785915 L9.1813451,12.5257519 C8.40187017,13.3051991 7.13698698,13.3040721 6.35866678,12.5257519 L1.41077405,7.57785915 C0.543404248,6.78002342 -8.8817842e-16,5.63564613 -8.8817842e-16,4.3646175 C-8.8817842e-16,1.9541783 1.95395254,0 4.3646175,0 C5.60449125,0 6.72403494,0.517216091 7.51825852,1.3473355 C7.60675643,1.43944557 7.69073914,1.53539356 7.76998089,1.63472794 C7.84989992,1.53539356 7.93365686,1.43944557 8.02170325,1.3473355 C8.81615259,0.517216091 9.93569628,0 11.1753443,0 C13.5860092,8.02060533e-16 15.5399618,1.9541783 15.5399618,4.3646175 C15.5399618,5.63564613 14.9965575,6.78024918 14.1294135,7.57785915 Z"
                />
            </svg>
        </div>
    );
}